import { Injectable, Component, OnInit, SimpleChanges } from '@angular/core';
declare var $: any;
declare var jQuery: any;


@Injectable()
@Component({
    selector: 'cat-menu-right',
    templateUrl: './menu-right.component.html',
})
export class MenuRightComponent implements OnInit {

    constructor() {        
    }
    
    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {            
    }

    ngDoCheck() {      
    }   
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/components/menu-right/menu-right.component.ts